import { request } from "../../../../services/api"
import type { BaseApiResponse } from "../../../../types/api.ts"
import type { ProposalValidationResult } from "../types.ts"

const PATHS = {
  proposalValidation: (id: string) => `/proposal/v2/proposals/${id}/validation/`
}

/**
 * `GET /proposal/v2/proposals/{id}/validation/` — the authoritative,
 * server-side recheck of a Proposal's own Sales Price vs. Milestone Total
 * and Proposal Duration vs. Milestone Duration, against whatever was just
 * saved. Only ever called at Generate time (the live-typing recalculation
 * uses `calculateContractValidation` locally, no network round trip) — the
 * response shape is byte-identical to `getContractValidation`'s, see
 * `../types.ts`. Refuses with 400 on a non-latest version — never called
 * from a read-only historical Proposal page in practice, since that page
 * never renders the Generate button this backs.
 */
export const getProposalValidation = (proposalId: string) =>
  request.api.get<ProposalValidationResult, BaseApiResponse<unknown>>(
    PATHS.proposalValidation(proposalId)
  )
